/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Demande
 * 1 = Intervention
 */
export enum TypeInterventionPhoto {
  Demande = 0,
  Intervention = 1
}
